import * as React from "react";
import { Tooltip } from "../Tooltip";
export class Checkbox extends React.PureComponent {
    render() {
        return (React.createElement("span", { className: "rj-checkbox rj-league-list__checkbox", "data-uat": "span-league-list-checkbox" },
            React.createElement("input", { id: this.props.id, type: "checkbox", checked: this.props.checked, className: "rj-checkbox__input rj-league-list__checkbox-input", onChange: (ev) => {
                    this.props.onChange(ev);
                }, "data-uat": "input-league-list-checkbox" }),
            React.createElement("label", { htmlFor: this.props.id, className: "rj-checkbox__label rj-league-list__checkbox-label", "data-uat": "label-league-list-checkbox" }, this.props.children),
            this.props.showTooltip && this.props.leagueId === this.props.selectedLeagueId &&
                React.createElement(Tooltip, { message: this.props.tooltipMessage, shouldShow: this.props.showTooltip })));
    }
}
//# sourceMappingURL=Checkbox.js.map